import { Spinner, Typography } from "components/Elements";
import React from "react";
import { useJoinNewsletter } from "../api/joinNewsletter";
import { Form } from "components/Form";
import Swal from "sweetalert2";

export const NewsLetter = () => {
  const newsletterMutation = useJoinNewsletter();

  return (
    <div className="mx-2 md:mx-32 my-4 mb-20">
      <Typography variant="primary" size="xl">
        Subscribe to our Newsletter
      </Typography>
      <div className="w-12 h-2 bg-blue-800"></div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div>
          <p className="mt-4 text-gray-600">
            Keep up with our latest posts from the blog, circulars, new examined
            programmes, upcoming events, and much more.
          </p>
        </div>
        <div>
          
            <Form
              id="join-newsletter"
              onSubmit={async (values) => {
                await newsletterMutation.mutateAsync({
                  data: values,
                });
                Swal.fire({
                  icon: 'success',
                  title: 'Thank You!',
                  text: 'You have successfully subscribed to our newsletter.',
                  showCancelButton: false,
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true,
                });
              }}
            >
              {({ register, formState }) => (
                <div className="flex flex-col md:flex-row">
                  <input
                    placeholder="Name"
                    type="text"
                    required={true}
                    className="py-3 px-4 border-0 bg-red-100 md:rounded-t-none focus:ring-blue-500 focus:border-blue-500 md:w-3/4"
                    {...formState.errors["name"]}
                    {...register("name")}
                  />
                  <input
                    placeholder="Email address"
                    type="email"
                    required={true}
                    className="py-3 px-4 border-0 bg-red-100 md:rounded-t-none focus:ring-blue-500 focus:border-blue-500 md:w-3/4"
                    {...formState.errors["email"]}
                    {...register("email")}
                  />
                  <button
                    type="submit"
                    className="bg-red-500 text-white py-2 px-4 rounded-b-md md:rounded-b-none md:rounded-r-md hover:bg-blue-700 mt-4 md:mt-0"
                  >
                    {newsletterMutation.isLoading ? <Spinner /> : 'Subscribe'}
                  </button>
                </div>
              )}
            </Form>
          
        </div>
      </div>
    </div>
  );
};
